var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"web-menu"},[_c('img',{staticClass:"web-menu-logo",style:({ visibility: _vm.websiteVisible ? 'visible' : 'hidden' }),attrs:{"src":require("@/assets/website/Logo.png")},on:{"click":function($event){return _vm.toPage('/')}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }